import { render, staticRenderFns } from "./MaterialCard.vue?vue&type=template&id=db10e8e0"
import script from "./MaterialCard.vue?vue&type=script&lang=js"
export * from "./MaterialCard.vue?vue&type=script&lang=js"
import style0 from "./MaterialCard.vue?vue&type=style&index=0&id=db10e8e0&prod&lang=sass"
import style1 from "./MaterialCard.vue?vue&type=style&index=1&id=db10e8e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports